class FlightDatesHelper {
  now(timezone) {
    return moment().tz(timezone);
  }

  parsedDate(date, timezone) {
    return moment.utc(date).tz(timezone, true);
  }

  pastEndDate(date, timezone) {
    if (!date) return false;

    return this.parsedDate(date, timezone).isBefore(this.now(timezone));
  }

  inactiveByBudgetFlightDates(budgetData) {
    if (Array.isArray(budgetData) && budgetData.length > 0) {
      var self = this;

      return (
        _.reject(budgetData, function (bd) {
          const timezone =
            bd[1] || bd.budget_flight_dates_timezone || "Etc/UTC";

          const budgetFlightDates = bd[0] || bd.budget_flight_dates;

          return (
            Array.isArray(budgetFlightDates) &&
            budgetFlightDates.length > 0 &&
            _.every(budgetFlightDates, function (budgetFlightDatesEntry) {
              return !self.now(timezone).isBetween(
                self.parsedDate(
                  budgetFlightDatesEntry[0] ||
                    // remove the Z from the end of the date, as it's not necessarily UTC and will cause issues
                    (budgetFlightDatesEntry.start_date || "").replace(/Z$/, ""),
                  timezone
                ),
                self.parsedDate(
                  budgetFlightDatesEntry[1] ||
                    // remove the Z from the end of the date, as it's not necessarily UTC and will cause issues
                    (budgetFlightDatesEntry.end_date || "").replace(/Z$/, ""),
                  timezone
                )
              );
            })
          );
        }).length < 1
      );
    } else {
      return false;
    }
  }
}

export default FlightDatesHelper;
